import React, { useCallback } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import apiClient from "../../../utils/apiClient";

const stripePromise = loadStripe(
  import.meta.env.VITE_API_STRIPE_TOKEN ||
    "pk_test_8hM4I5gZ0ocpgnvtOrgROi1J00kqrCPrP6"
);

const EmbeddedCheckoutComponent = ({ priceId, onBack }) => {
  const fetchClientSecret = useCallback(async () => {
    try {
      const { data } = await apiClient.post("/transactions/checkout", {
        price_id: priceId,
      });

      return data.client_secret;
    } catch (error) {
      console.error("Error al crear la sesión de checkout:", error);
      throw error;
    }
  }, [priceId]);

  const options = {
    fetchClientSecret,
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="mb-6">
        <button
          onClick={onBack}
          className="text-gray-600 hover:text-gray-900 flex items-center gap-2 mb-4 cursor-pointer hover:underline"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
          </svg>
          Regresar a planes
        </button>
        <p className="text-gray-600 mt-2">
          Completa tu información para procesar el pago de forma segura
        </p>
      </div>

      <div id="checkout" className="w-full">
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    </div>
  );
};

export default EmbeddedCheckoutComponent;
